// // import React, { useState, useEffect } from "react";
// // import { withRouter } from "react-router-dom";
// // import Subscription from "./Subscription";
// // import { getAllPlan } from "../services/plans";
// // import BreadCrumb from "./Cards/BreadCrumbs";
// // import { Link } from "react-router-dom";
// // import { connect } from "react-redux";
// // import { setCurrentUser } from "../redux/user/user.actions";
// // import Loader from "../utils/loader";
// // import authService from "../services/authService";
// // import subscription from "../services/subscription";
// // import { 
// //   Box, 
// //   Typography, 
// //   Button, 
// //   Container,
// //   Paper
// // } from "@mui/material";
// // import Grid from '@mui/material/Unstable_Grid2';
// // import AddCircleIcon from '@mui/icons-material/AddCircle';

// // function PricingPlan({ hide, currentUser }) {
// //   const [planList, setplanList] = useState([]);
// //   const [dashLink] = ["/admindashboard"];
// //   const [dashboardLink] = ["/subAdminDashboard"];
// //   const [loader, setLoader] = useState(false);
// //   const user = localStorage.getItem("Role") || "Individual";
  
// //   // useEffect(() => {
// //   //   getSubscriptions();
// //   // }, [user]);

// //   useEffect(() => {
// //   getSubscriptions();
// // }, []);

// //   const getSubscriptions = async () => {
// //     try {
// //       const response = await subscription.getSubscriptions();
// //       if (response.status === 200) {
// //         const allSubscriptions = response?.data;
// //         const organizationPlans = allSubscriptions.filter(
// //           (plan) => plan.userType === user
// //         );
// //         const plans = organizationPlans;

// //         if (plans.length >= 3) {
// //           const temp = plans[1];
// //           plans[1] = plans[2];
// //           plans[2] = temp;
// //         }

// //         let html = plans.map((plan) => {
// //           const content = unOrderList(plan.billingCycle);
// //           const planName = plan?.name;
// //           const nameOfTerms = plan?.billingCycle;
// //           const planMode = { mode: plan?.planMode };
// //           const termDetails = convertToObj(plan?.billingCycle);
// //           const plan_id = plan?._id;
// //           const defaultPlan = plan?.isDefault;
// //           return {
// //             heading: planName,
// //             ul: content,
// //             btn_list: nameOfTerms,
// //             price_detail: termDetails,
// //             plan_mode: planMode,
// //             plan_id: plan_id,
// //             defaultPlan: defaultPlan
// //           };
// //         });
// //         setplanList(html);
// //         setLoader(false);
// //       }
// //     } catch (error) {
// //       console.log(error, "Error while fetching subscriptions");
// //     }
// //   };

// //   const convertToObj = (termDetails) => {
// //     const termObj = termDetails.reduce((newObj, obj) => {
// //       const { duration: term, price, totalUsers, userCounts } = obj;

// //       if (!term) {
// //         console.warn("Encountered an item with an undefined term:", obj);
// //         return newObj;
// //       }

// //       if (!newObj[term]) {
// //         newObj[term] = [];
// //       }

// //       newObj[term].push({ price, totalUsers, userCounts });

// //       return newObj;
// //     }, {});

// //     return termObj;
// //   };

// //   const unOrderList = (contentObj) => {
// //     if (contentObj) {
// //       const ul = contentObj.map((cycle, index) => {
// //         const { duration, price, totalUsers, userCounts } = cycle;
// //         const subscriptionText = `${duration.charAt(0).toUpperCase() + duration.slice(1)} subscription: $${price}/${duration}${user === "Organization" ? `, Total Users: ${totalUsers}` : ''}`;
// //         const userCountText = `Users: Admin - ${userCounts?.admin}, Power Users - ${userCounts?.powerUser}, Regular Users - ${userCounts?.regularUser}`;
        
// //         return (
// //           <li key={index}>
// //             <div>{subscriptionText}</div>
// //             {user === "Organization" && <div>{userCountText}</div>}
// //           </li>
// //         );
// //       });
      
// //       return (
// //         <ul>
// //           <lh>Subscription Details</lh>
// //           {ul}
// //         </ul>
// //       );
// //     }

// //     return null;
// //   };

// //   return (
// //     <Box sx={{ 
// //       minHeight: '100vh',
// //       background: 'white',
// //       py: 6
// //     }}> 
// //       <Loader loading={loader} />
      
// //       <Container maxWidth="xl">
// //         {!hide && (
// //           <Box sx={{ 
// //             display: 'flex', 
// //             justifyContent: 'space-between', 
// //             alignItems: 'center',
// //             mb: 4
// //           }}>
// //             <Box />
// //             {currentUser && currentUser.isAdmin && (
// //               <Button
// //                 component={Link}
// //                 to="/addsubscription"
// //                 variant="contained"
// //                 startIcon={<AddCircleIcon />}
// //                 sx={{
// //                   borderRadius: 3,
// //                   textTransform: 'none',
// //                   px: 3,
// //                   py: 1.5,
// //                   fontWeight: 600
// //                 }}
// //               >
// //                 Manage Plans
// //               </Button>
// //             )}
// //           </Box>
// //         )}

// //         <Box sx={{ textAlign: 'center', mb: 6 }}>
// //           <Typography 
// //             variant="h4" 
// //             sx={{ 
// //               color: '#003366',
// //               fontWeight: 600,
// //               mb: 2,
// //               // 3472af
// //               textShadow: '0 2px 4px rgba(0,0,0,0.1)'
// //             }}
// //           >
// //             Explore for free and unlock additional features later on.
// //           </Typography>
          
// //           <Typography 
// //             variant="h3" 
// //             sx={{ 
// //               color: '#003366',
// //               fontWeight: 700,
// //               textShadow: '0 2px 4px rgba(0,0,0,0.1)'
// //             }}
// //           >
// //             {currentUser && currentUser.isAdmin ? "Plans" : "Select your plan"}
// //           </Typography>
// //         </Box>

// //         <Grid 
// //           container 
// //           spacing={4}
// //           sx={{
// //             display: 'flex',
// //             justifyContent: 'center',
// //             alignItems: 'stretch'
// //           }}
// //         >
// //           {planList.map((obj, index) => (
// //             <Grid 
// //               size={{ xs: 12, sm: 6, md: 4 }} 
// //               key={index}
// //               sx={{
// //                 display: 'flex',
// //                 maxWidth: '400px', // Maximum width for each card
// //                 width: '100%'
// //               }}
// //             >
// //               <Subscription
// //                 price_detail={obj.price_detail}
// //                 plan_id={obj.plan_id}
// //                 planName={obj.heading}
// //                 planList={obj.ul}
// //                 btn_list={obj.btn_list}
// //                 plan_mode={obj.plan_mode}
// //                 hide={hide}
// //                 defaultPlan={obj?.defaultPlan}
// //               />
// //             </Grid>
// //           ))}
// //         </Grid>
// //       </Container>
// //     </Box>
// //   );
// // }

// // const mapStateToProps = (state) => ({
// //   currentUser: state.user.currentUser,
// // });

// // const mapDispatchToProps = (dispatch) => ({
// //   setCurrentUser: (user) => dispatch(setCurrentUser(user)),
// // });

// // export default connect(
// //   mapStateToProps,
// //   mapDispatchToProps
// // )(withRouter(PricingPlan));

// import React, { useState, useEffect } from "react";
// import { withRouter } from "react-router-dom";
// import Subscription from "./Subscription";
// import { getAllPlan } from "../services/plans";
// import BreadCrumb from "./Cards/BreadCrumbs";
// import { Link } from "react-router-dom";
// import { connect } from "react-redux";
// import { setCurrentUser } from "../redux/user/user.actions";
// import Loader from "../utils/loader";
// import authService from "../services/authService";
// import subscription from "../services/subscription";
// import { 
//   Box, 
//   Typography, 
//   Button, 
//   Container,
//   Paper,
//   Stack,
//   Chip,
//   useTheme,
//   alpha
// } from "@mui/material";
// import Grid from '@mui/material/Unstable_Grid2';
// import AddCircleIcon from '@mui/icons-material/AddCircle';
// import DiamondIcon from '@mui/icons-material/Diamond';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// function PricingPlan({ hide, currentUser }) {
//   const [planList, setplanList] = useState([]);
//   const [dashLink] = ["/admindashboard"];
//   const [dashboardLink] = ["/subAdminDashboard"];
//   const [loader, setLoader] = useState(false);
//   const user = localStorage.getItem("Role") || "Individual";
//   const theme = useTheme();
  
//   useEffect(() => {
//     getSubscriptions();
//   }, []);

//   const getSubscriptions = async () => {
//     try {
//       const response = await subscription.getSubscriptions();
//       if (response.status === 200) {
//         const allSubscriptions = response?.data;
//         const organizationPlans = allSubscriptions.filter(
//           (plan) => plan.userType === user
//         );
//         const plans = organizationPlans;

//         if (plans.length >= 3) {
//           const temp = plans[1];
//           plans[1] = plans[2];
//           plans[2] = temp;
//         }

//         let html = plans.map((plan, index) => {
//           const content = unOrderList(plan.billingCycle);
//           const planName = plan?.name;
//           const nameOfTerms = plan?.billingCycle;
//           const planMode = { mode: plan?.planMode };
//           const termDetails = convertToObj(plan?.billingCycle);
//           const plan_id = plan?._id;
//           const defaultPlan = plan?.isDefault;
//           return {
//             heading: planName,
//             ul: content,
//             btn_list: nameOfTerms,
//             price_detail: termDetails,
//             plan_mode: planMode,
//             plan_id: plan_id,
//             defaultPlan: defaultPlan,
//             index: index,
//             isMostPopular: index === 1 && plans.length >= 2
//           };
//         });
//         setplanList(html);
//         setLoader(false);
//       }
//     } catch (error) {
//       console.log(error, "Error while fetching subscriptions");
//     }
//   };

//   const convertToObj = (termDetails) => {
//     const termObj = termDetails.reduce((newObj, obj) => {
//       const { duration: term, price, totalUsers, userCounts } = obj;

//       if (!term) {
//         console.warn("Encountered an item with an undefined term:", obj);
//         return newObj;
//       }

//       if (!newObj[term]) {
//         newObj[term] = [];
//       }

//       newObj[term].push({ price, totalUsers, userCounts });

//       return newObj;
//     }, {});

//     return termObj;
//   };

//   const unOrderList = (contentObj) => {
//     if (contentObj) {
//       const ul = contentObj.map((cycle, index) => {
//         const { duration, price, totalUsers, userCounts } = cycle;
//         const subscriptionText = `${duration.charAt(0).toUpperCase() + duration.slice(1)} subscription: $${price}/${duration}${user === "Organization" ? `, Total Users: ${totalUsers}` : ''}`;
//         const userCountText = `Users: Admin - ${userCounts?.admin}, Power Users - ${userCounts?.powerUser}, Regular Users - ${userCounts?.regularUser}`;
        
//         return (
//           <li key={index}>
//             <div>{subscriptionText}</div>
//             {user === "Organization" && <div>{userCountText}</div>}
//           </li>
//         );
//       });
      
//       return (
//         <ul>
//           <lh>Subscription Details</lh>
//           {ul}
//         </ul>
//       );
//     }

//     return null;
//   };

//   return (
//     <Box sx={{ 
//       minHeight: '100vh',
//       background: `linear-gradient(135deg, ${alpha(theme.palette.primary.light, 0.08)} 0%, ${alpha(theme.palette.secondary.light, 0.05)} 100%)`,
//       py: { xs: 4, md: 8 }
//     }}> 
//       <Loader loading={loader} />
      
//       <Container maxWidth="xl">
//         {!hide && (
//           <Box sx={{ 
//             display: 'flex', 
//             justifyContent: 'space-between', 
//             alignItems: 'center',
//             mb: 4,
//             flexWrap: 'wrap',
//             gap: 2
//           }}>
//             <Box />
//             {currentUser && currentUser.isAdmin && (
//               <Button
//                 component={Link}
//                 to="/addsubscription"
//                 variant="contained"
//                 startIcon={<AddCircleIcon />}
//                 sx={{
//                   borderRadius: 3,
//                   textTransform: 'none',
//                   px: 4,
//                   py: 1.5,
//                   fontWeight: 600,
//                   background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//                   boxShadow: `0 8px 20px ${alpha(theme.palette.primary.main, 0.3)}`,
//                   '&:hover': {
//                     transform: 'translateY(-2px)',
//                     boxShadow: `0 12px 28px ${alpha(theme.palette.primary.main, 0.4)}`,
//                   },
//                   transition: 'all 0.3s ease'
//                 }}
//               >
//                 Manage Plans
//               </Button>
//             )}
//           </Box>
//         )}

//         {/* Header Section */}
//         <Box sx={{ textAlign: 'center', mb: 8 }}>
//           <Chip
//             label="PRICING PLANS"
//             sx={{
//               backgroundColor: alpha(theme.palette.primary.main, 0.1),
//               color: theme.palette.primary.main,
//               fontWeight: 600,
//               letterSpacing: 1,
//               mb: 2,
//               px: 1,
//               borderRadius: 2
//             }}
//           />
//           <Typography 
//             variant="h3" 
//             sx={{ 
//               fontWeight: 800,
//               background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//               backgroundClip: 'text',
//               WebkitBackgroundClip: 'text',
//               color: 'transparent',
//               mb: 2
//             }}
//           >
//             {currentUser && currentUser.isAdmin ? "Subscription Plans" : "Choose Your Perfect Plan"}
//           </Typography>
          
//           <Typography 
//             variant="h6" 
//             sx={{ 
//               color: 'text.secondary',
//               maxWidth: '600px',
//               mx: 'auto',
//               fontWeight: 400
//             }}
//           >
//             {currentUser && currentUser.isAdmin 
//               ? "Manage and customize subscription plans for your users"
//               : "Get started with our flexible plans designed to scale with your needs"}
//           </Typography>
//         </Box>

//         {/* Plans Grid */}
//         <Grid 
//           container 
//           spacing={4}
//           sx={{
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'stretch'
//           }}
//         >
//           {planList.map((obj, index) => (
//             <Grid 
//               size={{ xs: 12, sm: 6, md: 4 }} 
//               key={index}
//               sx={{
//                 display: 'flex',
//                 maxWidth: { xs: '100%', md: '400px' },
//                 width: '100%',
//                 mx: 'auto'
//               }}
//             >
//               <Subscription
//                 price_detail={obj.price_detail}
//                 plan_id={obj.plan_id}
//                 planName={obj.heading}
//                 planList={obj.ul}
//                 btn_list={obj.btn_list}
//                 plan_mode={obj.plan_mode}
//                 hide={hide}
//                 defaultPlan={obj?.defaultPlan}
//                 isMostPopular={obj.isMostPopular}
//                 index={index}
//               />
//             </Grid>
//           ))}
//         </Grid>

//         {/* Footer Note */}
//         <Box sx={{ textAlign: 'center', mt: 8 }}>
//           <Typography variant="body2" sx={{ color: 'text.secondary' }}>
//             All plans include a 14-day free trial • No credit card required • Cancel anytime
//           </Typography>
//         </Box>
//       </Container>
//     </Box>
//   );
// }

// const mapStateToProps = (state) => ({
//   currentUser: state.user.currentUser,
// });

// const mapDispatchToProps = (dispatch) => ({
//   setCurrentUser: (user) => dispatch(setCurrentUser(user)),
// });

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(withRouter(PricingPlan));

import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import Subscription from "./Subscription";
import { getAllPlan } from "../services/plans";
import BreadCrumb from "./Cards/BreadCrumbs";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { setCurrentUser } from "../redux/user/user.actions";
import Loader from "../utils/loader";
import authService from "../services/authService";
import subscription from "../services/subscription";
import {
  Box,
  Typography,
  Button,
  Container,
  Chip,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

function PricingPlan({ hide, currentUser }) {
  const [planList, setplanList] = useState([]);
  const [billingPeriod, setBillingPeriod] = useState("monthly");
  const [dashLink] = ["/admindashboard"];
  const [dashboardLink] = ["/subAdminDashboard"];
  const [loader, setLoader] = useState(false);
  const user = localStorage.getItem("Role") || "Individual";

  useEffect(() => {
    getSubscriptions();
  }, []);

  const getSubscriptions = async () => {
    try {
      const response = await subscription.getSubscriptions();
      if (response.status === 200) {
        const allSubscriptions = response?.data;
        const organizationPlans = allSubscriptions.filter(
          (plan) => plan.userType === user
        );
        const plans = organizationPlans;

        if (plans.length >= 3) {
          const temp = plans[1];
          plans[1] = plans[2];
          plans[2] = temp;
        }

        let html = plans.map((plan) => {
          const content = unOrderList(plan.billingCycle);
          const planName = plan?.name;
          const nameOfTerms = plan?.billingCycle;
          const planMode = { mode: plan?.planMode };
          const termDetails = convertToObj(plan?.billingCycle);
          const plan_id = plan?._id;
          const defaultPlan = plan?.isDefault;
          const features = plan?.features || [];
          return {
            heading: planName,
            ul: content,
            features,
            btn_list: nameOfTerms,
            price_detail: termDetails,
            plan_mode: planMode,
            plan_id: plan_id,
            defaultPlan: defaultPlan,
          };
        });
        setplanList(html);
        setLoader(false);
      }
    } catch (error) {
      console.log(error, "Error while fetching subscriptions");
    }
  };

  const convertToObj = (termDetails) => {
    const termObj = termDetails.reduce((newObj, obj) => {
      const { duration: term, price, totalUsers, userCounts } = obj;
      if (!term) {
        console.warn("Encountered an item with an undefined term:", obj);
        return newObj;
      }
      if (!newObj[term]) {
        newObj[term] = [];
      }
      newObj[term].push({ price, totalUsers, userCounts });
      return newObj;
    }, {});
    return termObj;
  };

  const unOrderList = (contentObj) => {
    if (contentObj) {
      const ul = contentObj.map((cycle, index) => {
        const { duration, price, totalUsers, userCounts } = cycle;
        const subscriptionText = `${
          duration.charAt(0).toUpperCase() + duration.slice(1)
        } subscription: $${price}/${duration}${
          user === "Organization" ? `, Total Users: ${totalUsers}` : ""
        }`;
        const userCountText = `Users: Admin - ${userCounts?.admin}, Power Users - ${userCounts?.powerUser}, Regular Users - ${userCounts?.regularUser}`;

        return (
          <li key={index}>
            <div>{subscriptionText}</div>
            {user === "Organization" && <div>{userCountText}</div>}
          </li>
        );
      });

      return (
        <ul>
          <lh>Subscription Details</lh>
          {ul}
        </ul>
      );
    }
    return null;
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(160deg, #f0f4ff 0%, #fafbff 50%, #f5f0ff 100%)",
        py: 8,
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: "-120px",
          right: "-120px",
          width: "500px",
          height: "500px",
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(102,126,234,0.12) 0%, transparent 70%)",
          pointerEvents: "none",
        },
        "&::after": {
          content: '""',
          position: "absolute",
          bottom: "-100px",
          left: "-100px",
          width: "400px",
          height: "400px",
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(118,75,162,0.10) 0%, transparent 70%)",
          pointerEvents: "none",
        },
      }}
    >
      <Loader loading={loader} />

      <Container maxWidth="xl">
        {!hide && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mb: 4,
            }}
          >
            {currentUser && currentUser.isAdmin && (
              <Button
                component={Link}
                to="/addsubscription"
                variant="contained"
                startIcon={<AddCircleIcon />}
                sx={{
                  borderRadius: "12px",
                  textTransform: "none",
                  px: 3,
                  py: 1.5,
                  fontWeight: 600,
                  fontSize: "15px",
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  boxShadow: "0 4px 20px rgba(102,126,234,0.35)",
                  "&:hover": {
                    background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                    boxShadow: "0 6px 24px rgba(102,126,234,0.50)",
                    transform: "translateY(-1px)",
                  },
                  transition: "all 0.25s ease",
                }}
              >
                Manage Plans
              </Button>
            )}
          </Box>
        )}

        {/* Header */}
        <Box sx={{ textAlign: "center", mb: 3 }}>
          <Chip
            icon={<AutoAwesomeIcon sx={{ fontSize: "16px !important" }} />}
            label="Simple, transparent pricing"
            sx={{
              mb: 2,
              px: 1.5,
              py: 2.5,
              fontSize: "13px",
              fontWeight: 600,
              letterSpacing: "0.5px",
              background: "linear-gradient(135deg, rgba(102,126,234,0.12) 0%, rgba(118,75,162,0.12) 100%)",
              color: "#667eea",
              border: "1px solid rgba(102,126,234,0.25)",
              borderRadius: "100px",
              "& .MuiChip-icon": { color: "#667eea" },
            }}
          />
          <Typography
            variant="h3"
            sx={{
              fontWeight: 800,
              color: "#0f0c29",
              mb: 2,
              fontSize: { xs: "2rem", md: "2.75rem" },
              lineHeight: 1.15,
              letterSpacing: "-0.5px",
            }}
          >
            {currentUser && currentUser.isAdmin
              ? "Manage Plans"
              : "Choose the perfect plan"}
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: "#64748b",
              fontWeight: 400,
              fontSize: "17px",
              maxWidth: "520px",
              mx: "auto",
              lineHeight: 1.6,
            }}
          >
            Explore for free and unlock additional features whenever you're ready.
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: 1,
            mb: 4,
          }}
        >
          {["monthly", "yearly"].map((period) => (
            <Button
              key={period}
              onClick={() => setBillingPeriod(period)}
              variant={billingPeriod === period ? "contained" : "outlined"}
              sx={{
                borderRadius: "999px",
                px: 3,
                py: 1,
                textTransform: "none",
                fontWeight: 700,
                borderColor: "rgba(102,126,234,0.25)",
                background:
                  billingPeriod === period
                    ? "linear-gradient(135deg, #667eea 0%, #a855f7 100%)"
                    : "#ffffff",
                color: billingPeriod === period ? "#ffffff" : "#475569",
                boxShadow:
                  billingPeriod === period
                    ? "0 8px 22px rgba(102,126,234,0.28)"
                    : "none",
                "&:hover": {
                  borderColor: "#667eea",
                  background:
                    billingPeriod === period
                      ? "linear-gradient(135deg, #667eea 0%, #a855f7 100%)"
                      : "rgba(102,126,234,0.06)",
                },
              }}
            >
              {period.charAt(0).toUpperCase() + period.slice(1)}
            </Button>
          ))}
          {/* <Typography sx={{ color: "#22c55e", fontWeight: 700, fontSize: "14px" }}>
            Save 20%
          </Typography> */}
        </Box>

        {/* Plan Cards */}
        <Grid
          container
          spacing={2}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "stretch",
          }}
        >
          {planList.map((obj, index) => (
            <Grid
              xs={12}
              sm={6}
              md={3}
              key={index}
              sx={{
                display: "flex",
                maxWidth: { xs: "100%", sm: "360px", md: "330px", lg: "350px" },
                width: "100%",
              }}
            >
              <Subscription
                price_detail={obj.price_detail}
                plan_id={obj.plan_id}
                planName={obj.heading}
                planList={obj.ul}
                features={obj.features}
                btn_list={obj.btn_list}
                plan_mode={obj.plan_mode}
                hide={hide}
                defaultPlan={obj?.defaultPlan}
                selectedPlanPeriod={billingPeriod}
              />
            </Grid>
          ))}
        </Grid>

        {/* Trust Badges */}
        <Box
          sx={{
            mt: 8,
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: 4,
          }}
        >
          {[
            { icon: "🔒", label: "Secure Payment", sub: "SSL encrypted" },
            { icon: "↩️", label: "Cancel Anytime", sub: "No lock-in contracts" },
            { icon: "⚡", label: "Instant Access", sub: "Start in seconds" },
          ].map((item, i) => (
            <Box
              key={i}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                px: 3,
                py: 1.5,
                borderRadius: "14px",
                background: "rgba(255,255,255,0.8)",
                backdropFilter: "blur(10px)",
                border: "1px solid rgba(102,126,234,0.12)",
                boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
              }}
            >
              <Typography sx={{ fontSize: "22px" }}>{item.icon}</Typography>
              <Box>
                <Typography sx={{ fontWeight: 700, fontSize: "13px", color: "#1a1a2e", lineHeight: 1.2 }}>
                  {item.label}
                </Typography>
                <Typography sx={{ fontSize: "12px", color: "#94a3b8" }}>
                  {item.sub}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentUser: (user) => dispatch(setCurrentUser(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PricingPlan));
